<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AWKUmD/tc-custom/9781466852594.jpg?1731010948495" alt="This image is the cover for the book You Are Mine, Nine Circles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">You Are Mine, Nine Circles
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In the Nine Circles Club, there's a fine line between pleasure and pain, sin and salvation, heaven and hell. And it takes one bold pair of lovers to cross it in<i> You Are Mine </i>by Jackie Ashenden.</b><br/><br/><b><i>He's master of the game.</i></b><br/> Zac Rutherford is one of the most powerful and sought-after men in New York's private club scene. Masterful and demanding, he attracts beautiful women willing to surrender to his every whim, every desire, and every command. But Zac is in love with one woman, and one woman only. She is his true passion-and sole obsession. A glorious angel in the flesh...who refuses to be touched by any man.<br/><br/><b><i>She doesn't play by the rules.</i></b><br/> Eva King owes her life to Zac. Seven years ago, he rescued her from darkness. Still, in spite of her attraction to Zac, she refuses to allow any man to touch her body, let alone her heart. But when a dangerous enemy from Eva's past reappears, Zac is the only one who can save her-if she's willing to bare her soul, shed her inhibitions, and surrender control...<i>to him</i>.<br/><b>The Nine Circles series is:</b><br/><b>"Sexy, emotional." </b>-Laurelin Paige, <i>New York Times</i> bestselling author <br/><b>"Sinfully sexy" </b>-Opal Carew, <i>New York Times</i> bestselling author</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jackie Ashenden
      </h2>
      
      <p class="authorDescription body article">Jackie Ashenden lives in Auckland, New Zealand with her husband, the inimitable Dr Jax, two kids and two cats. When she's not torturing alpha males and their stroppy heroines, she can be found drinking chocolate martinis, reading anything she can lay her hands on, posting random crap on her blog, or being forced to go mountain biking with her husband. Jackie writes the dark, sexy contemporary romance series <I>Nine Circles</I> for St Martin's Press, including the books <I>Mine to Take</I> and<I> Make You Mine</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1a7bbdc6